import * as React from 'react';
import { FC } from 'react';
import classNames from 'classnames';
import styles from '../assets/invoice-info.module.scss';

interface Props {
    active: number | undefined;
}

const InvoiceStatusComponent: FC<Props> = ({ active }: Props) => {
    const statuses: { [key: number]: string } = {
        1: 'generated-stat',
        2: 'deleted-stat',
        3: 'uploaded-stat',
        4: 'sent-stat',
        5: 'outstanding-stat',
        6: 'scheduled-stat',
        7: 'paid-stat',
        8: '',
        9: 'underpaid-stat',
        10: 'writtenoff-stat',
    };
    if (active) {
        statuses[active] = `${statuses[active]} ${styles.activeStatus}`;
    }

    return (
        <div className={classNames(styles.invoiceStatus)}>
            <h2 style={{ textAlign: 'center' }}>Invoice Status</h2>
            <div className={classNames(styles.statusList)}>
                <div className={classNames(styles.statusItemType)}>
                    <div className={classNames(styles.statusItem, styles.twoArrow, styles.full, statuses[1])}>
                        <span>Generated</span>
                    </div>
                    <div className={classNames(styles.line2)}></div>
                    <div className={classNames(styles.arrowNew2, styles.absArrow)}></div>
                    <div className={classNames(styles.statusItem, styles.absStatusItem2, statuses[10])}>
                        <span>Written-off</span>
                    </div>
                    <div className={classNames(styles.line)}></div>
                    <div className={classNames(styles.arrowNew, styles.absArrow)}></div>
                    <div className={classNames(styles.statusItem, styles.absStatusItem, statuses[2])}>
                        <span>Delete</span>
                    </div>
                </div>

                <div className={classNames(styles.arrowNew)}></div>
                <div className={classNames(styles.statusItem, styles.arrowOne, statuses[3])}>
                    <span>Uploaded</span>
                </div>
                <div className={classNames(styles.arrowNew)}></div>

                <div className={classNames(styles.statusItem, styles.arrow, statuses[4])}>
                    <span>Sent</span>
                </div>
                <div className={classNames(styles.arrowNew)}></div>
                <div className={classNames(styles.statusItem, styles.arrow, statuses[5])}>
                    <span>Outstanding payment</span>
                </div>
                <div className={classNames(styles.arrowNew)}></div>
                <div className={classNames(styles.statusItemType)}>
                    <div className={classNames(styles.statusItem, styles.twoArrow, styles.full, statuses[6])}>
                        <span>Scheduled for payment</span>
                    </div>
                    <div className={classNames(styles.line)}></div>
                    <div className={classNames(styles.arrowNew, styles.absArrow)}></div>
                    <div className={classNames(styles.statusItem, styles.absStatusItem, statuses[9])}>
                        <span>Underpaid</span>
                    </div>
                </div>

                <div className={classNames(styles.arrowNew)}></div>
                <div className={classNames(styles.statusItem, statuses[7], 'mr-0')}>
                    <span>Paid</span>
                </div>
            </div>
        </div>
    );
};

export default InvoiceStatusComponent;
